import { render, staticRenderFns } from "./ModalChangeDestination.vue?vue&type=template&id=2d4ec589&scoped=true&"
import script from "./ModalChangeDestination.vue?vue&type=script&lang=js&"
export * from "./ModalChangeDestination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d4ec589",
  null
  
)

export default component.exports